export class FormHeaderElement {
    title: string = '';
    value: string = '';
  
    constructor(title: string = '', value: string = '') {
      this.title = title;
      this.value = value;
    }
  
    setValue(value: string) {
      this.value = value;
    }
  }
  